import { render, staticRenderFns } from "./PersonnelTab.vue?vue&type=template&id=4b4cb26c"
import script from "./PersonnelTab.vue?vue&type=script&lang=js"
export * from "./PersonnelTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports